<template>
    <div class="comPager" v-if="totalPages">
        <el-pagination
            background
            :page-size="1"
            layout=" prev, pager, next"
            :total="totalPages.pages > 1000 ? 1000 : totalPages.pages"
            :current-page.sync="totalCurrent"
            :prev-text="'上一页'"
            :next-text	="'下一页'"
            :pager-count="pagerCount"
            @current-change="jumpToPage"
            @prev-click="jumpToPage"
            @next-click="jumpToPage"
        >
        </el-pagination>
        <span class="total">共有<span class="verdanF14 color999">{{totalPages.pages}}</span>页</span>
        <div class="jumpBox">
            到第
            <input type="text" class="inputJump" v-model="jumpVal" @change="changeNum(jumpVal)" v-on:keyup.13="jumpTo">
            页
        </div>
    </div>
</template>

<script>
export default {
    name: "comPager",
    props:{
        totalPages:{
            default:{},
            type:Object
        },
        totalCurrent: {
            default: 1,
            type:Number
        }
    },
    data(){
        return{
            jumpVal: this.$route.query.page ? this.$route.query.page : 1,
            pages:1,
            pagerCount:5,
        }
    },
    computed:{
        pageTotal(){
            return this.totalPages
        },
        pageNum(){
            return this.totalPages ? this.totalPages>1000?1000:this.totalPages:1
        }
    },
    methods:{
        jumpToPage(val){
            
            document.body.scrollIntoView()
            this.$emit('handlePages',val)
            // this.$emit("pageChange",Number(val));
            // this.jumpVal=val;
        },
        changeNum(item){
            console.log(item);
            // this.jumpVal = Number(this.jumpVal) < 0 || !Number(this.jumpVal) ? 1 : this.jumpVal;
        },
        jumpTo(){
            let curPage = parseInt(this.jumpVal) > this.totalPages.pages ? this.totalPages.pages : parseInt(this.jumpVal);
            if(curPage){
                this.pages=curPage;
                this.jumpToPage(curPage);
            }

        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
// 分页样式
.comPager{
    /* width: 1180px; */
    margin: 40px auto 20px;
    display:flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-pagination {
        display:inline-block;
        text-align: center;
        button,span:not([class*=suffix]){
            padding: 0 5px;
            line-height: 36px;
            display: inline-block;
            height: 35px;
            font-size: 14px;
            vertical-align: top;
            text-decoration: none;
            color: #000;
            font-family: Verdana;
            background: transparent;}
        .el-pager{font-size: 0;
            li{    padding: 0 13px 0 14px;
                line-height: 36px;
                display: inline-block;
                height: 35px;
                font-size: 14px;
                vertical-align: top;
                text-decoration: none;
                background-color: transparent;
                transition: .2s all ease-in-out;font-weight: normal;
                color: #000;
                font-family: Verdana;}
            li:hover,.active,.el-pagination.is-background .el-pager li:not(.disabled).active{
                background: #e6e6e6;
                color: #333;
                height: 35px;
                line-height: 35px;
                border: 0;}
            .more{border:0;}
        }
        &.is-background .btn-next, &.is-background .btn-prev, &.is-background .el-pager li{
            margin: 0 5px 0 0;
        }
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active{background: #000;color: #FEFEFE;}
    .total{font-size: 14px;color:#999999;margin:0 10px;
        i{color:#329d15}
    }
    .jumpBox{display:inline-block;line-height: 30px;color:#999999;font-size: 14px;
        .inputJump{width:35px;height:35px;border: 1px solid #e6e6e6;text-align: center;color:#999999;margin:0 2px;box-sizing: border-box;}
    }
}
</style>